export enum commodityTypes {
  GET_COMMODITY_DEFINITIONS = '@@commodity/GET_COMMODITY_DEFINITIONS',
  GET_COMMODITY_SUCCESS = '@@commodity/GET_COMMODITY_SUCCESS',
  GET_COMMODITY_FAIL = '@@commodity/GET_COMMODITY_FAIL',

  GET_COMMODITY_BY_GUID_DEFINITIONS = '@@commodity/GET_COMMODITY_BY_GUID_DEFINITIONS',
  GET_COMMODITY_BY_GUID_SUCCESS = '@@commodity/GET_COMMODITY_BY_GUID_SUCCESS',
  GET_COMMODITY_BY_GUID_FAIL = '@@commodity/GET_COMMODITY_BY_GUID_FAIL',

  GET_GROUPNAME = '@@commodity/GET_GROUPNAME',

  GET_MILESTONESCONFIG_COMMODITY = "@commodity/GET_MILESTONECONFIG",
  GET_MILESTONESCONFIG_COMMODITY_SUCCESSS = "@commodity/GET_MILESTONECONFIG_SUCCESS",
  GET_MILESTONESCONFIG_COMMODITY_FAIL = "@commodity/GET_MILESTONECONFIG_FAIL",

  GET_PACKINGLIST_COMMODITY = "@commodity/GET_PACKINGLIST",
  GET_PACKINGLIST_COMMODITY_SUCCESSS = "@commodity/GET_PACKINGLIST_SUCCESS",
  GET_PACKINGLIST_COMMODITY_FAIL = "@commodity/GET_PACKINGLIST_FAIL"
}
